// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OCow","option":"styles_option__10_uC","active":"styles_active__2dr74"};